/* eslint-disable prefer-const */
import $ from 'jquery';

const scrollToAddToBag = () => {
  let handleAddToBagButtonClick = true;
  if (handleAddToBagButtonClick) {
    handleAddToBagButtonClick = false;
    $(document).on('click', '.stickyAddToBag', () => {
      // eslint-disable-next-line jquery/no-animate
      $('html,body').animate({
        scrollTop: $('.product-detail__details-section-sticky-container').offset().top - $('.header-sticky').height(),
      },
      'slow');
      const addToCartButton = document.querySelector('.product-detail__add-to-cart .add-to-cart');
      if (addToCartButton) {
        if (addToCartButton && addToCartButton.disabled) {
          addToCartButton.disabled = false;
          $('.product-detail__add-to-cart .add-to-cart').click();
          addToCartButton.disabled = true;
        } else {
          $('.product-detail__add-to-cart .add-to-cart').click();
          addToCartButton.classList.add('buttonActive');
        }
      }
      handleAddToBagButtonClick = true;
    });
  }

  $(document).on('click', '.product-detail__add-to-cart .add-to-cart', () => {
    if (document.querySelector('.stickyAddToBag')) {
      document.querySelector('.stickyAddToBag').classList.add('buttonActive');
    }
  });

  $(document).on('click', 'body', (event) => {
    const stickyAddToCartButton = document.querySelector('.stickyAddToBag');
    const inPageAddToCartButton = document.querySelector('.product-detail__add-to-cart .add-to-cart');
    if (stickyAddToCartButton && inPageAddToCartButton
      && event.target !== stickyAddToCartButton && event.target !== inPageAddToCartButton) {
      document.querySelector('.stickyAddToBag').classList.remove('buttonActive');
      document.querySelector('.product-detail__add-to-cart .add-to-cart').classList.remove('buttonActive');
    }
  });
};

const isInViewport = function (el) {
  const rect = el.getBoundingClientRect();
  const stickyHeader = document.querySelector('.header-sticky');
  return (
    rect.bottom - stickyHeader.offsetHeight >= 0
    && rect.top - 20 < (document.documentElement.clientHeight || window.innerHeight)
  );
};

const toggleStickyBar = () => {
  const backToTopButton = document.querySelector('.back-to-top');
  const stickyBarMenu = document.querySelector('.stickyBarMenu');
  $(window).on('resize scroll', () => {
    const inPageATB = document.querySelector('.product-detail__add-to-cart .add-to-cart');
    if (inPageATB && isInViewport(inPageATB)) {
      // eslint-disable-next-line jquery/no-class
      $('.stickyBarMenu').removeClass('stickyBarMenuShow');
    } else {
      // eslint-disable-next-line jquery/no-class
      $('.stickyBarMenu').addClass('stickyBarMenuShow');
      backToTopButton.classList.add('d-none');
    }
  });
  $(document).ready(() => {
    if (stickyBarMenu) {
      backToTopButton.style.display = 'none';
    }
    const inPageATB = document.querySelector('.product-detail__add-to-cart .add-to-cart');
    if (inPageATB && isInViewport(inPageATB)) {
      // eslint-disable-next-line jquery/no-class
      $('.stickyBarMenu').removeClass('stickyBarMenuShow');
    } else {
      // eslint-disable-next-line jquery/no-class
      $('.stickyBarMenu').addClass('stickyBarMenuShow');
      backToTopButton.classList.add('d-none');
    }
  });
};

const addToWishlist = () => {
  let handleAddToWishlistButtonClick = true;
  $(document).on('click', '.stickyAddToWishlist', () => {
    if (handleAddToWishlistButtonClick) {
      $('.add-to-wish-list').click();
      handleAddToWishlistButtonClick = false;
    }
    setTimeout(() => {
      handleAddToWishlistButtonClick = true;
    }, 1000);
  });
};

const syncStickyBarButtons = () => {
  $(document.body).on('product:afterAddToCart', (e, data) => {
    let representedProductAdded = document.querySelector('.stickyAddToBag')
      ? document.querySelector('.stickyAddToBag').classList.contains('buttonActive')
      : null;
    if (representedProductAdded && data && !data.error) {
      // eslint-disable-next-line max-len
      if (document.querySelector('.stickyBarBagButton.stickyViewToBag') && document.querySelector('.stickyBarBagButton.stickyAddToBag')) {
        document.querySelector('.stickyBarBagButton.stickyViewToBag').classList.remove('inactive');
        document.querySelector('.stickyBarBagButton.stickyAddToBag').classList.add('inactive');
      }
    }
  });
  document.addEventListener('product:removedFromWishlist', () => {
    // eslint-disable-next-line max-len
    if (document.querySelector('.stickyBarBagButton.stickyViewToWishlist') && document.querySelector('.stickyBarBagButton.stickyAddToWishlist')) {
      document.querySelector('.stickyBarBagButton.stickyViewToWishlist').classList.remove('active');
      document.querySelector('.stickyBarBagButton.stickyAddToWishlist').classList.add('active');
    }
  });
  document.addEventListener('product:addedToWishlist', () => {
    // eslint-disable-next-line max-len
    if (document.querySelector('.stickyBarBagButton.stickyViewToWishlist') && document.querySelector('.stickyBarBagButton.stickyAddToWishlist')) {
      document.querySelector('.stickyBarBagButton.stickyViewToWishlist').classList.add('active');
      document.querySelector('.stickyBarBagButton.stickyAddToWishlist').classList.remove('active');
    }
  });
};

export default () => {
  scrollToAddToBag();
  toggleStickyBar();
  addToWishlist();
  syncStickyBarButtons();
};
